import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';

export const appRoutes = [
	{
		path:'',
		redirectTo:'home',
		pathMatch:'full',
		data: {activeUrl: '1'}
	},
	{
		path:'home',
		component:HomeComponent,
		data: {activeUrl: '1'}
	},
	{
		path:'industry',
		loadChildren:'./industry/industry.module#IndustryModule',
		data: {activeUrl: '2'}
	},
	{
		path:'about',
		loadChildren:'./about/about.module#AboutModule',
		data: {activeUrl: '3'}
	},
	{
		path:'contact',
		component:ContactComponent,
		data: {activeUrl: '4'}
	},
	{
		path:'**',//fallback router must in the last
		component:HomeComponent,
	}
]



// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/app.routes.ts